import { ApiProperty } from '@nestjs/swagger';
import { IsString, IsNotEmpty } from 'class-validator';

export class UploadFileDto {
  @ApiProperty({
    description: 'The module where the file will be used',
    example: 'newsfeed',
    required: true
  })
  @IsString()
  @IsNotEmpty()
  module!: string;
}
